import { createPageFromGuard } from './page-from-guard'
import { createPageTitleGuard } from './page-title-guard'
import { createPermissionGuard } from './permission-guard'

import type { Router } from 'vue-router'

export function setupRouterGuards(router: Router) {
  createPageFromGuard(router)
  createPermissionGuard(router)
  createPageTitleGuard(router)
}
